export default __webpack_public_path__ + "assets/media/13-12-1021-4-1003578-main.jpg";